var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHarmful1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8335 9.99992C3.8335 6.60006 6.60031 3.83325 10.0002 3.83325C13.4 3.83325 16.1668 6.60006 16.1668 9.99992C16.1668 13.3998 13.4 16.1666 10.0002 16.1666C6.60031 16.1666 3.8335 13.3998 3.8335 9.99992ZM4.16683 9.99992C4.16683 13.2167 6.78335 15.8333 10.0002 15.8333C13.217 15.8333 15.8335 13.2167 15.8335 9.99992C15.8335 6.78311 13.217 4.16659 10.0002 4.16659C6.78335 4.16659 4.16683 6.78311 4.16683 9.99992Z",
    fill: "black",
    stroke: "#220046"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6665 10C8.21879 10 8.6665 9.55228 8.6665 9C8.6665 8.44772 8.21879 8 7.6665 8C7.11422 8 6.6665 8.44772 6.6665 9C6.6665 9.55228 7.11422 10 7.6665 10Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3288 9.99067C12.8785 9.99067 13.3242 9.54504 13.3242 8.99533C13.3242 8.44563 12.8785 8 12.3288 8C11.7791 8 11.3335 8.44563 11.3335 8.99533C11.3335 9.54504 11.7791 9.99067 12.3288 9.99067Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 11.3333C8.00016 11.3333 7.3335 13.3333 7.3335 13.3333H12.6668C12.6668 13.3333 12.0002 11.3333 10.0002 11.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarmful1);
export default __webpack_public_path__ + "static/media/Harmful1.aaf1f7ffc398f50d0b7671bc7369ebf7.svg";
export { ForwardRef as ReactComponent };